import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Draggable } from "gsap/Draggable";

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger, Draggable);

export default function initInitGsap() {
    document.addEventListener('DOMContentLoaded', () => {

        // Fade up elements animation
        const fadeUpElements = document.querySelectorAll('.anmi-fadeup');
        fadeUpElements.forEach((element, index) => {
            gsap.from(element, {
                scrollTrigger: {
                    trigger: element,
                    start: 'top 80%',
                    toggleActions: 'play none none reset',
                },
                duration: 1,
                opacity: 0,
                y: 50,
                ease: 'power2.out',
                stagger: 0.15,
                delay: index * 0.15
            });
        });

        // Banner image parallax
        const bannerImages = document.querySelectorAll('.banner-image');
        bannerImages.forEach((wrapper) => {
            const img = wrapper.querySelector('img');
            if (!img) return;

            gsap.fromTo(img,
                { yPercent: -15 },
                {
                    yPercent: 15,
                    ease: 'none',
                    scrollTrigger: {
                        trigger: wrapper,
                        start: 'top bottom',
                        end: 'bottom top',
                        scrub: true,
                    }
                }
            );
        });

    });
}
